import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Col, Row, Button, Dropdown } from "react-bootstrap";
import { NGDropdownListItem, SXDropdown } from "@common/components/ui-components/SXDropdown";
import { SXModalBase } from "./SXModal";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { useTranslation } from "react-i18next";
import { openModal, closeModal, selectModalById } from "../../features/ui/uiSlice";
import "../../../i18n";
import { languages } from "../../config/languages";
import { selectProject } from "../../features/projects/projectSlice";
import { SXResultTables } from "../SXResultTable";
import {
  IDesignResultDictionary,
  IDisplacementDictionary,
  IReactionForceDictionary,
  ISectionForceDictionary,
} from "@common/types/sharedTypes";
interface ResultTableModalProps {
  isModalOpen: boolean;
  isUlsComb?: boolean;
  isSlsComb?: boolean;
  codeCheckResultExists?: boolean;
  elementResultsForces: ISectionForceDictionary;
  supportForces: IReactionForceDictionary;
  displacement: IDisplacementDictionary;
  designResult: IDesignResultDictionary;
}

export const ResultTableModal = (props: ResultTableModalProps) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const handleLanguageSelect = async (langCode: string) => {
    await i18n.changeLanguage(langCode);
  };
  const selProject = useAppSelector(selectProject);
  const currentLanguage = languages.find((lang) => lang.code === i18n.language);

  return (
    <SXModalBase
      header={t("result_tables_.label")}
      show={props.isModalOpen}
      size="lg"
      close={() => {
        dispatch(closeModal("resultTableModal"));
      }}
      body={
        <Container>
          <Row style={{ marginBottom: "3rem" }}>
            <Col xs={12}>
              {selProject && selProject.data?.data?.output && (
                <SXResultTables
                  selectedLcomb="-1"
                  results={selProject.data.data.output}
                  units={{ getDisplayHeader: (a: string) => a ?? "" }}
                  supportForces={props.supportForces}
                  displacement={props.displacement}
                  designResult={props.designResult}
                  elementResultsForces={props.elementResultsForces}
                  codeCheckResultExists={props.codeCheckResultExists}
                  isSlsComb={props.isSlsComb ?? false}
                  isUlsComb={props.isUlsComb ?? false}
                  user={{}}
                  loadComboHandle={() => {}}
                  setGraphSymbol={() => {}}
                />
              )}
            </Col>
          </Row>
        </Container>
      }
      footer={
        <>
          <Button
            className="modal-btn"
            onClick={() => {
              dispatch(closeModal("resultTableModal"));
            }}
          >
            {t("general.cancel")}
          </Button>
          <Button
            id="disclaimerok"
            className="modal-btn"
            onClick={() => {
              dispatch(closeModal("resultTableModal"));
            }}
          >
            {t("general.ok")}
          </Button>
        </>
      }
    />
  );
};
